import React from 'react';

import './RadioButton.scss';

type RadioButtonTypes = {
    checked: boolean;
    onClick: () => void;
    label: string;
    name?: string;
};

const RadioButton = ({
        checked, onClick,
        label,
        name = 'radio-button',
    }: RadioButtonTypes) => {
    return (
        <div className="b-radio-button">
            <input
                type="radio"
                name={name}
                checked={checked}
                onChange={onClick}
                data-testid={name}
            />
            <label className="radio-button-label">
                {label}
            </label>
        </div>
    );
};

export default RadioButton;
